import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'dc-dot-loader',
  standalone: true,
  imports: [NgClass],
  templateUrl: './dot-loader.component.html',
  styleUrl: './dot-loader.component.scss'
})
export class DotLoaderComponent {
  theme = input<'light' | 'primary'>('primary');
}
